
import {SET_USER_INFO ,SET_USER_INFO_KEY_VALUE, LOGOUT_USER, SET_ACTIVE_KNOWLEDGE_ID, SET_ACTIVE_APP, SET_PROJECT_CONFIG, SET_FUNCTIONS_AND_GOALS, SET_ROLE_LIST } from "../../actions/app.type";
const initialState = {
    loggedIn:false,
    current_companay:{},
    current_workspace:{},
    current_role:{},
    preferredProfile: null,
    profileData:"",
    activeKnowledgeId: null,
    isThinkingModeEnabled: false,
    apiVersionName: 'V1'
};

export default (state = initialState, action: {
  type: string;
  payload: any; 
}) => {  
  switch (action.type) {
    case SET_USER_INFO_KEY_VALUE:
      if (typeof action.payload === 'object' && action.payload !== null && 'key' in action.payload && 'value' in action.payload) {
        return { ...state, [action.payload.key]: action.payload.value };
      }
      return state;
    case SET_USER_INFO:
        return { ...state, ...action.payload, loggedIn: true ,};
    case LOGOUT_USER:
        return initialState;
    case SET_ACTIVE_KNOWLEDGE_ID:
        return { ...state, activeKnowledgeId: action.payload };
    case SET_ACTIVE_APP:
        return { ...state, activeApp: action.payload };
    case SET_PROJECT_CONFIG:
        return {
          ...state,
          isThinkingModeEnabled: action.payload?.isThinkingModeEnabled ?? false,
          apiVersionName: action.payload?.apiVersionName ?? 'V1'
        };
    case SET_FUNCTIONS_AND_GOALS:
        return { ...state, functionsAndGoals: action.payload };
    case SET_ROLE_LIST:
        return { ...state, roleList: action.payload };
    default:
      return state;
  }
};